import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Admin from './admin';
import AdminLogin from './adminLogin';
import ModerationView from './moderation-view';

export default function App() {
  const [loginInfo, setLoginInfo] = React.useState({
    loggedIn: false,
  });

  return (
    <Router basename={"/app"}>
      <Routes>
        <Route path="/admin" element={<Admin loginInfo={loginInfo} setLoginInfo={setLoginInfo} />} />
        <Route path="/admin-login" element={<AdminLogin loginInfo={loginInfo} setLoginInfo={setLoginInfo} />} />
        <Route path="*" element={<Navigate to="/admin-login" replace />} />
        <Route path="/moderation-view" element={<ModerationView />} />
      </Routes>
    </Router>
  );
}
